<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Employee</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <employee-form :data="data"></employee-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import EmployeeForm from './EmployeeForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'EmployeeDialog',
  data() {
    return {
      data: {
        id: null,
        first_name: '',
        last_name: '',
        address: '',
        role: '',
        mobile: '',
        telephone: '',
        email: '',
        date_of_birth: '',
        start_date: '',
        end_date: '',
        bank_name: '',
        account_name: '',
        bsb_number: '',
        account_number: '',
        emergency_contact: '',
        notes: '',
        password: ''
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'employees', 'item'],
  components: {
    EmployeeForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting employee data for id ', this.item.id)
      axios
        .get('api/admin/employees/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new employee')
      axios
        .post('api/admin/employees/create', this.data)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.loading = false
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating employee data for id ', this.item.id)
      axios
        .put(`api/admin/employees/${this.item.id}`, this.data)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        id: null,
        first_name: '',
        last_name: '',
        address: '',
        role: '',
        mobile: '',
        telephone: '',
        email: '',
        date_of_birth: '',
        start_date: '',
        end_date: '',
        bank_name: '',
        account_name: '',
        bsb_number: '',
        account_number: '',
        emergency_contact: '',
        notes: '',
        password: ''
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
